import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ProgramIncludes() {
  return <section className="py-20 bg-[#FFFDD0]/30" data-id="element-51">
      <div className="max-w-7xl mx-auto px-6" data-id="element-52">
        <div className="text-center mb-20" data-id="element-53">
          <span className="text-[#D4AF37] uppercase tracking-[0.2em] text-xs font-bold mb-3 block" data-id="element-54">
            El Programa Paso a Paso
          </span>
          <h2 className="text-3xl md:text-4xl font-heading text-gray-900" data-id="element-55">
            Tu Viaje de Transformación en 21 Días
          </h2>
        </div>

        {/* Phase 1: Detox y Desinflamación */}
        <div className="flex flex-col md:flex-row items-center gap-12 mb-24" data-id="element-56">
          <div className="w-full md:w-1/2 order-2 md:order-1" data-id="element-57">
            <div className="max-w-md ml-auto" data-id="element-58">
              <span className="text-[#D4AF37] font-bold tracking-widest text-sm uppercase mb-2 block" data-id="element-59">
                Semana 1
              </span>
              <h3 className="text-3xl font-heading text-gray-900 mb-6" data-id="element-60">
                Fase 1: Detox y Desinflamación
              </h3>
              <p className="text-gray-600 mb-8 leading-relaxed font-light text-lg" data-id="element-61">
                Comenzamos liberando la tensión acumulada y activando el sistema
                linfático. Notarás tu rostro más descansado, luminoso y menos hinchado desde los
                primeros 3 días.
              </p>
              <ul className="space-y-4" data-id="element-62">
                <li className="flex items-start" data-id="element-63">
                  <CheckCircle2 className="w-5 h-5 text-[#D4AF37] mt-1 mr-3 flex-shrink-0" data-id="element-64" />
                  <span className="text-gray-700" data-id="element-65">Ejercicios de drenaje linfático profundo</span>
                </li>
                <li className="flex items-start" data-id="element-66">
                  <CheckCircle2 className="w-5 h-5 text-[#D4AF37] mt-1 mr-3 flex-shrink-0" data-id="element-67" />
                  <span className="text-gray-700" data-id="element-68">Técnicas para borrar ojeras y "puffy face"</span>
                </li>
                <li className="flex items-start" data-id="element-69">
                  <CheckCircle2 className="w-5 h-5 text-[#D4AF37] mt-1 mr-3 flex-shrink-0" data-id="element-70" />
                  <span className="text-gray-700" data-id="element-71">Preparación de la piel y uso de aceites</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full md:w-1/2 order-1 md:order-2" data-id="element-72">
            <div className="relative" data-id="element-73">
              <div className="absolute inset-0 bg-[#FADADD] transform translate-x-4 translate-y-4 -z-10 rounded-xl" data-id="element-74"></div>
              <img src="https://cdn.shopify.com/s/files/1/0691/5312/8522/files/Gemini_Generated_Image_1z8ur81z8ur81z8u.jpg?v=1771958533" alt="Drenaje Linfático Facial" className="w-full h-[450px] object-cover shadow-lg grayscale hover:grayscale-0 transition-all duration-700 rounded-xl" data-id="element-75" />
            </div>
          </div>
        </div>

        {/* Phase 2: Esculpido Facial */}
        <div className="flex flex-col md:flex-row items-center gap-12 mb-24" data-id="element-76">
          <div className="w-full md:w-1/2" data-id="element-77">
            <div className="relative" data-id="element-78">
              <div className="absolute inset-0 bg-[#D4AF37]/20 transform -translate-x-4 translate-y-4 -z-10 rounded-xl" data-id="element-79"></div>
              <img src="https://cdn.shopify.com/s/files/1/0691/5312/8522/files/Gemini_Generated_Image_fn76apfn76apfn76.jpg?v=1771958615" alt="Esculpido de Mandíbula y Jawline" className="w-full h-[450px] object-cover shadow-lg grayscale hover:grayscale-0 transition-all duration-700 rounded-xl" data-id="element-80" />
            </div>
          </div>
          <div className="w-full md:w-1/2" data-id="element-81">
            <div className="max-w-md mr-auto" data-id="element-82">
              <span className="text-[#D4AF37] font-bold tracking-widest text-sm uppercase mb-2 block" data-id="element-83">
                Semana 2
              </span>
              <h3 className="text-3xl font-heading text-gray-900 mb-6" data-id="element-84">
                Fase 2: Esculpido Facial (Jawline)
              </h3>
              <p className="text-gray-600 mb-8 leading-relaxed font-light text-lg" data-id="element-85">
                Trabajo muscular intenso para definir el óvalo facial.
                Rutinas específicas para reducir la papada, levantar los pómulos y marcar la mandíbula de forma natural.
              </p>
              <ul className="space-y-4" data-id="element-86">
                <li className="flex items-start" data-id="element-87">
                  <CheckCircle2 className="w-5 h-5 text-[#D4AF37] mt-1 mr-3 flex-shrink-0" data-id="element-88" />
                  <span className="text-gray-700" data-id="element-89">Definición del arco mandibular</span>
                </li>
                <li className="flex items-start" data-id="element-90">
                  <CheckCircle2 className="w-5 h-5 text-[#D4AF37] mt-1 mr-3 flex-shrink-0" data-id="element-91" />
                  <span className="text-gray-700" data-id="element-92">Tonificación de cuello y pómulos</span>
                </li>
                <li className="flex items-start" data-id="element-93">
                  <CheckCircle2 className="w-5 h-5 text-[#D4AF37] mt-1 mr-3 flex-shrink-0" data-id="element-94" />
                  <span className="text-gray-700" data-id="element-95">Ejercicios de resistencia muscular facial</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Phase 3: Borrador de Arrugas */}
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-96">
          <div className="w-full md:w-1/2 order-2 md:order-1" data-id="element-97">
            <div className="max-w-md ml-auto" data-id="element-98">
              <span className="text-[#D4AF37] font-bold tracking-widest text-sm uppercase mb-2 block" data-id="element-99">
                Semana 3
              </span>
              <h3 className="text-3xl font-heading text-gray-900 mb-6" data-id="element-100">
                Fase 3: Borrador de Arrugas
              </h3>
              <p className="text-gray-600 mb-8 leading-relaxed font-light text-lg" data-id="element-101">
                Nos enfocamos en la relajación muscular profunda para suavizar las líneas de expresión finas, logrando un efecto de "Lifting Natural" integral.
              </p>
              <ul className="space-y-4" data-id="element-102">
                <li className="flex items-start" data-id="element-103">
                  <CheckCircle2 className="w-5 h-5 text-[#D4AF37] mt-1 mr-3 flex-shrink-0" data-id="element-104" />
                  <span className="text-gray-700" data-id="element-105">Suavizado de líneas en frente y entrecejo</span>
                </li>
                <li className="flex items-start" data-id="element-106">
                  <CheckCircle2 className="w-5 h-5 text-[#D4AF37] mt-1 mr-3 flex-shrink-0" data-id="element-107" />
                  <span className="text-gray-700" data-id="element-108">Tratamiento para "patas de gallo"</span>
                </li>
                <li className="flex items-start" data-id="element-109">
                  <CheckCircle2 className="w-5 h-5 text-[#D4AF37] mt-1 mr-3 flex-shrink-0" data-id="element-110" />
                  <span className="text-gray-700" data-id="element-111">Rutina final de mantenimiento diario</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full md:w-1/2 order-1 md:order-2" data-id="element-112">
            <div className="relative" data-id="element-113">
              <div className="absolute inset-0 bg-[#FADADD] transform translate-x-4 translate-y-4 -z-10 rounded-xl" data-id="element-114"></div>
              <img src="https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Piel radiante y sin arrugas" className="w-full h-[450px] object-cover shadow-lg grayscale hover:grayscale-0 transition-all duration-700 rounded-xl" data-id="element-115" />
            </div>
          </div>
        </div>

      </div>
    </section>;
}